export default "__VITE_ASSET__xb1Z$uzI__"